import "./AboutUs.module.css";
import UstMenu from "@/reusable_sections/Header";
import TwentyFiveYearsAcademicLegacy from "./sections/TwentyFiveYearsAcademicLegacy";
import ProfessionalTraining from "./sections/ProfessionalTraining";
import CorporateFooter from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <UstMenu />
      <TwentyFiveYearsAcademicLegacy />
      <ProfessionalTraining />
      <CorporateFooter />
    </div>;
}